import CryptoJS from "crypto-js";

const PHONE_SECRET = process.env.REACT_APP_PHONE_SECRET;

export const decryptPhone = (encryptedPhone) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedPhone, PHONE_SECRET);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    console.error("Failed to decrypt phone number");
    return "";
  }
};
